import React, {FunctionComponent, useEffect, useState} from 'react';
import {Box, makeStyles, Theme, Typography} from '@material-ui/core';
import {useIntl} from "react-intl";


const useStyles = makeStyles<Theme>(theme => ({
  infoWrap:{
    borderRight: '1px solid #D9D9D9',
    paddingRight: 37,
    marginBottom: 31,
    paddingBottom: 8,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
      border: 0,
      borderBottom: '1px solid #D9D9D9',
      paddingBottom: 34
    }
  },
  infoTitle:{
    fontWeight: 700,
    marginBottom : 18,
    [theme.breakpoints.down('xs')]: {
      fontSize: 22
    }
  },
  infoText:{
    color: '#000',
    fontSize: 14,
    marginBottom: 30
  },
  infoPerevaguTitle:{
    fontWeight: 700,
    marginBottom: 18,
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  infoPerWr:{
    display: 'grid',
    gridGap: '30px 32px',
    gridTemplateColumns: '42% auto',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: 'auto',
      gridGap: 18,
      display: 'none'
    }
  },
  infoPer:{
    display: 'grid',
    gridTemplateColumns: '27px auto',
    gridGap: 7
  },
  infoPerImgWr:{
    width: 27,
    height: 27,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    "& img":{
      maxWidth: '100%',
    }
  },
  infoPerText:{
    fontSize: 12,
    fontWeight: 500
  },
  formLoginBtn:{
    fontWeight: 500,
    fontSize: 16,
    color: '#979FA9',
    '&:hover':{
      color: '#000'
    }
  },
  infoImg:{
    display: 'block',
    alignSelf: 'flex-end',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    }
  },
  formCont:{
    display: 'grid',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      paddingLeft:0
    }
  },
  regCallBack:{
    fontWeight: 700,
    fontSize: 14,
    color: '#fff',
    textDecoration: 'none'
  },
  formLogoWr:{
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
      marginBottom: 22
    }
  },
  formParent:{
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100% - 56px)',
      margin: '0 auto 27px'
    }
  },
  infoImgMob:{
    display: 'none',
    [theme.breakpoints.down('xs')]: {
      display: 'block',
      margin: 'auto',
      marginTop: 40
    }
  },
  infoPerevaguTitleMob:{
    fontSize: 13,
    border: '1px solid #000',
    borderRadius: 4,
    display: 'none',
    alignItems: 'center',
    padding: '11px 0',
    justifyContent: 'center',
    fontWeight: 700,
    marginTop: 32,
    [theme.breakpoints.down('xs')]: {
      display: 'flex'
    }
  },
  infoPerevaguTitleMobHide:{
    display: 'none'
  },
  infoPerevaguPlus:{
    marginRight: 7
  },
  infoPerWrShow:{
    display: 'grid'
  }
}));

interface RieltorBenefitsProps {

}

const RieltorBenefits: FunctionComponent<RieltorBenefitsProps> = (props: RieltorBenefitsProps) => {
  const classes = useStyles();

  const intl = useIntl();
  const {formatMessage: fm} = intl;

  const [perevaguStatus, setPerevaguStatus] = useState(false);
  const showHidePerevagu = () => {
    setPerevaguStatus(!perevaguStatus);

  }

  const getWidth = () => window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;

  let [width, setWidth] = useState(getWidth());

  useEffect(() => {
    // timeoutId for debounce mechanism
    let timeoutId: any = null;
    const resizeListener = () => {
      // prevent execution of previous setTimeout
      clearTimeout(timeoutId);
      // change width from the state object after 150 milliseconds
      timeoutId = setTimeout(() => setWidth(getWidth()), 150);
    };
    // set resize listener
    window.addEventListener('resize', resizeListener);

    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener('resize', resizeListener);
    }
  }, [])

  return (
    <>

      <Typography variant="h6" className={classes.infoPerevaguTitle}>
        {fm({id: 'registration_screen.info.perevagu.title'})}:
      </Typography>
      <Box className={
        `${classes.infoPerWr} ${width<600 && perevaguStatus ? classes.infoPerWrShow : ''}`}


      >
        <Box className={classes.infoPer}>
          <Box className={classes.infoPerImgWr}>
            <img src={require('./icons/icon_avatar.svg')}/>
          </Box>
          <Box className={classes.infoPerText}>{fm({id: 'registration_screen.info.perevagu.per_avatar'})}</Box>
        </Box>
        <Box className={classes.infoPer}>
          <Box className={classes.infoPerImgWr}>
            <img src={require('./icons/icon_coins.svg')}/>
          </Box>
          <Box className={classes.infoPerText}>{fm({id: 'registration_screen.info.perevagu.per_coins'})}</Box>
        </Box>
        <Box className={classes.infoPer}>
          <Box className={classes.infoPerImgWr}>
            <img src={require('./icons/icon_flatfy.svg')}/>
          </Box>
          <Box className={classes.infoPerText}>{fm({id: 'registration_screen.info.perevagu.per_flatfy'})}</Box>
        </Box>
        <Box className={classes.infoPer}>
          <Box className={classes.infoPerImgWr}>
            <img src={require('./icons/icon_mobile.svg')}/>
          </Box>
          <Box className={classes.infoPerText}>{fm({id: 'registration_screen.info.perevagu.per_mobile'})}</Box>
        </Box>
        <Box className={classes.infoPer}>
          <Box className={classes.infoPerImgWr}>
            <img src={require('./icons/icon_viber.svg')}/>
          </Box>
          <Box className={classes.infoPerText}>{fm({id: 'registration_screen.info.perevagu.per_viber'})}</Box>
        </Box>
        <Box className={classes.infoPer}>
          <Box className={classes.infoPerImgWr}>
            <img src={require('./icons/icon_stats.svg')}/>
          </Box>
          <Box className={classes.infoPerText}>{fm({id: 'registration_screen.info.perevagu.per_stats'})}</Box>
        </Box>
      </Box>
      <Box className={
        `${classes.infoPerevaguTitleMob} ${width<600 && !perevaguStatus ? '' : classes.infoPerevaguTitleMobHide}`} onClick={showHidePerevagu}>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" className={classes.infoPerevaguPlus}>
          <path d="M13.4292 7.99026L13.4292 6.56594L7.78247 6.56594L7.78247 0.919189L6.35815 0.919189L6.35815 6.56594L0.711401 6.56594L0.711402 7.99026L6.35815 7.99026L6.35815 13.637L7.78247 13.637L7.78247 7.99026L13.4292 7.99026Z" fill="black"/>
        </svg>
        {fm({id: 'registration_screen.info.perevagu.title'})}
      </Box>

      <Box className={
        `${classes.infoPerevaguTitleMob} ${width<600 && perevaguStatus ? '' : classes.infoPerevaguTitleMobHide}`} onClick={showHidePerevagu}>
        <svg width="14" height="2" viewBox="0 0 14 2" fill="none" className={classes.infoPerevaguPlus}>
          <path d="M13.4292 1.50588L13.4292 0.0815675L7.78247 0.0815669L6.35815 0.0815669L0.711401 0.081567L0.711402 1.50588L6.35815 1.50588L7.78247 1.50588L13.4292 1.50588Z" fill="black"/>
        </svg>
        {fm({id: 'registration_screen.info.perevagu.hide_perevagu'})}
      </Box>
    </>
  );
};

export default RieltorBenefits;